module.exports = __webpack_public_path__ + "img/2010 radtour ehrenabteilung 009.515a615d.jpg";